import { Typography } from "@mui/material";
import { EXTERNAL_PROVIDE } from "../../config/cacheKey";
import CustomisedButton from "../../components/button/button";
import EmptyStyle from "../../components/emptyStyles/emptyStyle";

import { useExternalLogin } from "../../hooks/useExternalLogin";


export default function ExternalRoute({ message = 'مشکلی رخ داده است' }: { message: string }) {
    const { externalLogin, loadingExternalLogin } = useExternalLogin();
    const providerToken = new URLSearchParams(window.location.search).get('token');

    const handleRoute = () => {
        if (!providerToken || loadingExternalLogin) return;
        sessionStorage.setItem(EXTERNAL_PROVIDE, 'externalProvider');
        externalLogin({loginProvider: 'Kaman', externalToken: providerToken});
    };
    return (
        <div className="w-full h-full flex flex-col justify-center items-center gap-20 p-20">
            <div>
                <EmptyStyle text={message} icon={<img src="/images/externalRouteError.svg" />} emphasisedWords={[]} emphasisedWordsColor="" >
                    <Typography sx={{ color: "var(--primary-text-color)" }} style={{ fontSize: ".75rem", fontWeight: 'bold' }}> متاسفانه در حال حاضر <span style={{ color: '#FF617C' }}>امکان ورود به سامانه</span> وجود ندارد!</Typography>
                </EmptyStyle>
            </div>
            <div className="w-full">

                <CustomisedButton title="تلاش مجدد" disable={loadingExternalLogin || !providerToken} onClick={handleRoute} type="button" />
            </div>
        </div>
    )
}

